module.exports = __webpack_public_path__ + "img/9788970713595.70de0622.jpg";